import ColorStyles from '@Styles/colors.scss';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Button from '@Components/Button/Button';
import OrganizationSelector from '@Components/OrganizationSelector/OrganizationSelector';
import TeamSelector from '@Components/TeamsSelector/TeamsSelector';
import { IProject, ViewProjectType } from '@Data/projects/Interfaces';
import { ITeam } from '@Data/teams/Interfaces';
import { ManageProjectType } from '../ManageProject/ManageProjectDialog';
import ProjectCardList from '../ProjectCards/ProjectCardList';
import SelectProjectSortField from '../ProjectSortingComponents/SelectProjectSortField';
import SelectProjectSortOrder from '../ProjectSortingComponents/SelectProjectSortOrder';
import SelectProjectView from '../ProjectSortingComponents/SelectProjectView';
import ProjectsList from '../ProjectsList/ProjectsList';
import Styles from './HomeDashboard.scss';

interface IHomeDashboardProps {
    projects: Array<IProject>;
    areProjectsLoading: boolean;
    onProjectClick: (project: IProject) => void;
    onCreateProject: () => void;
    onDeleteProject: (project: IProject, callback?: () => void) => void;
    onEdit: (project: IProject, manageProjectType: ManageProjectType) => void;
}

const HomeDashboard = (props: IHomeDashboardProps) => {
    const {
        projects,
        areProjectsLoading,
        onProjectClick,
        onCreateProject,
        onDeleteProject,
        onEdit,
    } = props;

    const [isQcCurrentJobsOpen, setIsQcCurrentJobsOpen] =
        useState<boolean>(false);
    const [viewOption, setViewOption] = useState<ViewProjectType>(
        ViewProjectType.CARD
    );

    const projectsHtml =
        viewOption === ViewProjectType.CARD ? (
            <ProjectCardList
                isLoading={areProjectsLoading}
                onClick={onProjectClick}
                onEdit={onEdit}
                onDelete={onDeleteProject}
                onCreateProject={onCreateProject}
                projects={projects}
            />
        ) : (
            <ProjectsList
                isLoading={areProjectsLoading}
                onClick={onProjectClick}
                onEdit={onEdit}
                onDelete={onDeleteProject}
                onCreateProject={onCreateProject}
                projects={projects}
            />
        );

    return (
        <React.Fragment>
            <div className={Styles.homeDashboardContainer}>
                <div
                    id="home-dashboard-title-container"
                    className={Styles.titleContainer}
                >
                    <div className={Styles.selectorsContainer}>
                        <OrganizationSelector />
                        <TeamSelector />
                    </div>
                    <div className={Styles.sortOptionsContainer}>
                        <SelectProjectSortField />
                        <SelectProjectSortOrder />
                        <SelectProjectView
                            selectedViewType={viewOption}
                            onSelectViewType={setViewOption}
                        />
                    </div>
                </div>
                <div
                    id="projects-container"
                    className={Styles.projectHtmlContainer}
                >
                    {projectsHtml}
                </div>
            </div>
        </React.Fragment>
    );
};

export default HomeDashboard;
